import React from 'react'
import './Buttons.css'
import { isAuthorised } from '../../utils/common';

const FilledButton = ({
    title,
    Aicon,
    Bicon,
    handleClick,
    className,
    styles,
}) => {
    return (
        <button
            className={className ? className : "filled-btn"}
            onClick={handleClick}
        >
            {
                Aicon && 
                <Aicon />
            }
            {title}
            {
                Bicon && 
                <Bicon />
            }
        </button>
    )
}

export default FilledButton